var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.40342C0 0.904474 0.404473 0.5 0.903416 0.5H14.0966C14.5955 0.5 15 0.904474 15 1.40342C15 1.90236 14.5955 2.30683 14.0966 2.30683H0.903415C0.404472 2.30683 0 1.90236 0 1.40342ZM0 6C0 5.50106 0.404473 5.09659 0.903416 5.09659H14.0966C14.5955 5.09659 15 5.50106 15 6C15 6.49895 14.5955 6.90342 14.0966 6.90342H0.903415C0.404472 6.90342 0 6.49895 0 6ZM0.903416 9.69319C0.404473 9.69319 0 10.0977 0 10.5966C0 11.0955 0.404473 11.5 0.903416 11.5H9.09658C9.59553 11.5 10 11.0955 10 10.5966C10 10.0977 9.59553 9.69319 9.09658 9.69319H0.903416Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.e6b60243583100cbf455a2e4598364f5.svg";
export { ForwardRef as ReactComponent };